/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_107Inputs */

const vi_carrier_status_107 = /** @type {(inputs: Carrier_Status_107Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đối tác yêu cầu huỷ đơn`)
};

/**

* @param {Carrier_Status_107Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_107 = /** @type {((inputs?: Carrier_Status_107Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_107Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_107(inputs)
});